{
  "chart": "แฟ้มประวัติผู้ป่วย",
  "mrn": "MRN",
  "demographics": {
    "pageTitle": "ข้อมูลประชากร",
    "loading": "กำลังโหลดข้อมูลประชากรผู้ป่วย...",
    "loadError": "โหลดข้อมูลประชากรผู้ป่วยไม่สำเร็จ",
    "returnToDashboard": "กลับสู่หน้าหลัก",
    "updatedSuccess": "อัปเดตข้อมูลประชากรผู้ป่วยเรียบร้อย",
    "updateError": "อัปเดตข้อมูลประชากรผู้ป่วยไม่สำเร็จ",
    "sections": {
      "personalInformation": "ข้อมูลส่วนตัว",
      "identification": "การพิสูจน์ตัวตน",
      "contactInformation": "ข้อมูลติดต่อ",
      "address": "ที่อยู่",
      "languageAndPreferences": "ภาษาและความต้องการ",
      "specialFlags": "ธงพิเศษ",
      "recordInformation": "ข้อมูลเวชระเบียน"
    },
    "fields": {
      "fullName": "ชื่อ-นามสกุล",
      "alternativeName": "ชื่ออื่น",
      "preferredName": "ชื่อที่ใช้เรียก",
      "dateOfBirth": "วันเกิด",
      "birthTime": "เวลาเกิด",
      "age": "อายุ",
      "legalGender": "เพศตามกฎหมาย",
      "genderIdentity": "อัตลักษณ์ทางเพศ",
      "sexAtBirth": "เพศแรกเกิด",
      "race": "เชื้อชาติ",
      "ethnicity": "ชาติพันธุ์",
      "nationality": "สัญชาติ",
      "mrn": "MRN",
      "nationalIdType": "ประเภทบัตรประชาชน",
      "nationalIdNumber": "เลขบัตรประชาชน",
      "passportNumber": "เลขที่หนังสือเดินทาง",
      "passportCountry": "ประเทศที่ออกหนังสือเดินทาง",
      "primaryPhone": "โทรศัพท์หลัก",
      "mobilePhone": "โทรศัพท์มือถือ",
      "email": "อีเมล",
      "preferredContactMethod": "ช่องทางติดต่อที่ต้องการ",
      "addressLine1": "ที่อยู่บรรทัดที่ 1",
      "addressLine2": "ที่อยู่บรรทัดที่ 2",
      "city": "เมือง",
      "stateProvince": "จังหวัด",
      "postalCode": "รหัสไปรษณีย์",
      "country": "ประเทศ",
      "primaryLanguage": "ภาษาหลัก",
      "secondaryLanguage": "ภาษารอง",
      "interpreterRequired": "ต้องการล่าม",
      "vipStatus": "สถานะ VIP",
      "confidentialityLevel": "ระดับการรักษาความลับ",
      "medicalTourist": "นักท่องเที่ยวเชิงการแพทย์",
      "homeCountry": "ประเทศต้นทาง",
      "status": "สถานะ",
      "deceased": "เสียชีวิต",
      "created": "วันที่สร้าง",
      "lastModified": "แก้ไขล่าสุด",
      "passportOnFile": "หนังสือเดินทางอยู่ในแฟ้ม",
      "organDonorStatus": "สถานะการบริจาคอวัยวะ"
    },
    "statusValues": {
      "active": "ใช้งาน",
      "inactive": "ไม่ใช้งาน"
    },
    "deceasedSummary": "ใช่ ({{date}})",
    "deceasedDateUnknown": "ไม่ทราบวันที่",
    "legalGender": {
      "label": "เพศตามกฎหมาย",
      "values": {
        "male": "ชาย",
        "female": "หญิง",
        "other": "อื่นๆ",
        "unknown": "ไม่ทราบ"
      },
      "selectPlaceholder": "เลือกเพศ"
    },
    "sexAtBirth": {
      "label": "เพศแรกเกิด",
      "values": {
        "female": "หญิง",
        "male": "ชาย",
        "other": "อื่น ๆ",
        "unknown": "ไม่ทราบ"
      },
      "notRecorded": "ไม่มีการบันทึก"
    },
    "preferredContactMethod": {
      "label": "ช่องทางติดต่อที่ต้องการ",
      "values": {
        "phone": "โทรศัพท์",
        "mobile": "มือถือ",
        "email": "อีเมล",
        "sms": "SMS"
      },
      "notSpecified": "ไม่ระบุ"
    },
    "validation": {
      "fullNameRequired": "ต้องระบุชื่อ-นามสกุล",
      "dateOfBirthRequired": "ต้องระบุวันเกิด",
      "countryRequired": "ต้องระบุประเทศ",
      "primaryLanguageRequired": "ต้องระบุภาษาหลัก",
      "invalidEmail": "อีเมลไม่ถูกต้อง",
      "nationalIdValidationFailed": "ตรวจสอบเลขบัตรประชาชนไม่สำเร็จ: {{error}}",
      "invalidBirthTime": "เวลาเกิดต้องอยู่ในรูปแบบ HH:MM"
    },
    "organDonor": {
      "notRecorded": "ไม่ได้บันทึก",
      "registered": "ลงทะเบียนบริจาค",
      "optedOut": "ปฏิเสธการบริจาค",
      "notRegistered": "ไม่ได้ลงทะเบียน",
      "unknown": "ไม่ทราบ"
    }
  },
  "registration": {
    "title": "ลงทะเบียนผู้ป่วย",
    "subtitle": "ลงทะเบียนผู้ป่วยรายใหม่ในระบบ",
    "submit": "ลงทะเบียนผู้ป่วย",
    "submitting": "กำลังลงทะเบียน...",
    "checkingDuplicates": "กำลังตรวจสอบรายการซ้ำ...",
    "registerNew": "ลงทะเบียนผู้ป่วยใหม่",
    "registeredSuccess": "ลงทะเบียนผู้ป่วยสำเร็จ",
    "registerError": "ลงทะเบียนผู้ป่วยไม่สำเร็จ",
    "validationNationalIdFailed": "ตรวจสอบเลขบัตรประชาชนไม่สำเร็จ: {{error}}",
    "sections": {
      "basicInformation": "ข้อมูลพื้นฐาน",
      "identification": "การพิสูจน์ตัวตน",
      "contactInformation": "ข้อมูลติดต่อ",
      "address": "ที่อยู่",
      "languageAndCommunication": "ภาษาและการสื่อสาร",
      "additionalInformation": "ข้อมูลเพิ่มเติม"
    },
    "fields": {
      "facility": "สถานพยาบาลที่ลงทะเบียน"
    },
    "placeholders": {
      "fullName": "ตัวอย่าง: Tan Wei Ming หรือ ก้อง สมชาย",
      "alternativeName": "อักษรโรมัน (ถ้ามี)",
      "preferredName": "ชื่อเรียกที่ผู้ป่วยต้องการ",
      "nationalIdNumberDefault": "กรอกเลขบัตรประชาชน",
      "primaryPhone": "+66 81 234 5678",
      "mobilePhone": "+66 81 234 5678",
      "email": "patient@example.com",
      "facility": "เลือกสถานพยาบาล"
    },
    "helperText": {
      "fullName": "กรอกชื่อ-นามสกุลตามเอกสารราชการ",
      "facility": "สถานพยาบาลที่ลงทะเบียนผู้ป่วยรายนี้ เจ้าหน้าที่ของสถานพยาบาลนี้จะสามารถเปิดดูเวชระเบียนได้"
    },
    "flags": {
      "vipPatient": "ผู้ป่วย VIP",
      "medicalTourist": "นักท่องเที่ยวเชิงการแพทย์"
    },
    "duplicate": {
      "title": "พบผู้ป่วยที่อาจซ้ำ",
      "body": "ผู้ป่วยที่มีอยู่ต่อไปนี้ตรงกับข้อมูลที่คุณกรอก:",
      "mrnLabel": "MRN",
      "dobLabel": "DOB",
      "idLabel": "ID",
      "matchSummary": "ความตรงกัน: {{score}}% ({{reasons}})",
      "useExisting": "ใช้รายการเดิม",
      "createNew": "นี่คือผู้ป่วยรายใหม่",
      "restricted": {
        "title_one": "มีรายการที่อาจตรงกัน {{count}} รายการซึ่งคุณไม่มีสิทธิ์ดู",
        "title_other": "มีรายการที่อาจตรงกัน {{count}} รายการซึ่งคุณไม่มีสิทธิ์ดู",
        "body": "ผู้ป่วยรายนี้อาจมีเวชระเบียนอยู่แล้วที่สถานพยาบาลอื่น โปรดติดต่อฝ่ายเวชระเบียนก่อนสร้างระเบียนใหม่ — ไม่แสดงรายละเอียดเนื่องจากระเบียนดังกล่าวอยู่นอกสิทธิ์การเข้าถึงของคุณ"
      },
      "overrideReasonLabel": "เหตุผลที่ยังคงลงทะเบียน",
      "overrideReasonPlaceholder": "เช่น ยืนยันกับผู้ป่วยแล้วว่าเป็นคนละคน",
      "overrideReasonHelp": "ระบบจะบันทึกไว้ในบัญชีของคุณ การสร้างเวชระเบียนซ้ำสำหรับคนเดียวกันทำให้ประวัติแยกจากกัน",
      "registerAnyway": "ยังคงลงทะเบียน"
    }
  },
  "search": {
    "title": "ค้นหาผู้ป่วย",
    "subtitle": "ค้นหาและจัดการเวชระเบียนผู้ป่วย",
    "placeholder": "ค้นหาด้วยชื่อผู้ป่วย, MRN หรือ ID...",
    "advancedFilters": "ตัวกรองขั้นสูง",
    "filters": {
      "mrnPlaceholder": "ตัวอย่าง: P0000000001",
      "fullNamePlaceholder": "ชื่อผู้ป่วย",
      "phonePlaceholder": "หมายเลขโทรศัพท์",
      "emailPlaceholder": "ที่อยู่อีเมล"
    },
    "filterLabels": {
      "mrn": "MRN",
      "fullName": "ชื่อ-นามสกุล",
      "dateOfBirth": "วันเกิด",
      "phone": "โทรศัพท์",
      "email": "อีเมล",
      "country": "ประเทศ",
      "status": "สถานะ",
      "vip": "VIP"
    },
    "vipFilter": {
      "all": "ทั้งหมด",
      "vipOnly": "เฉพาะ VIP",
      "nonVipOnly": "เฉพาะที่ไม่ใช่ VIP"
    },
    "statusFilter": {
      "all": "ทั้งหมด",
      "active": "ใช้งาน",
      "inactive": "ไม่ใช้งาน"
    },
    "countryFilter": {
      "all": "ทุกประเทศ"
    },
    "clearFilters": "ล้างตัวกรอง",
    "dateOfBirthAria": "ตัวกรองวันเกิด",
    "columns": {
      "mrn": "MRN",
      "fullName": "ชื่อ-นามสกุล",
      "dob": "DOB",
      "gender": "เพศ",
      "phone": "โทรศัพท์",
      "country": "ประเทศ",
      "status": "สถานะ"
    },
    "results": {
      "searching": "กำลังค้นหาผู้ป่วย...",
      "loadError": "โหลดผู้ป่วยไม่สำเร็จ โปรดลองอีกครั้ง",
      "retry": "ลองอีกครั้ง",
      "empty": "ไม่พบผู้ป่วย โปรดปรับเงื่อนไขการค้นหา",
      "showing": "แสดง {{from}} – {{to}} จาก {{total}} รายการ"
    }
  },
  "myPatients": {
    "title": "ผู้ป่วยของฉัน",
    "subtitle": "ผู้ป่วยที่อยู่ในความดูแลของคุณ",
    "searchPlaceholder": "กรองตามชื่อหรือ MRN...",
    "columns": {
      "mrn": "MRN",
      "patient": "ชื่อ-นามสกุล",
      "dob": "DOB",
      "sex": "เพศ",
      "class": "ประเภท",
      "relationship": "ความเกี่ยวข้อง",
      "admitted": "วันรับเข้า"
    },
    "kind": {
      "attending": "แพทย์ผู้ดูแล",
      "careTeam": "ทีมดูแล",
      "referral": "การส่งต่อ",
      "coverage": "เวรแทน"
    },
    "restrictedBadge": "จำกัด",
    "empty": {
      "title": "ไม่มีผู้ป่วยในแผงของคุณ",
      "body": "ผู้ป่วยที่คุณดูแล อยู่เวรแทน หรือรับส่งต่อจะแสดงที่นี่",
      "censusAction": "เปิดบอร์ดเตียง"
    },
    "results": {
      "searching": "กำลังโหลดผู้ป่วยของคุณ...",
      "loadError": "โหลดผู้ป่วยของคุณไม่สำเร็จ โปรดลองอีกครั้ง",
      "retry": "ลองอีกครั้ง",
      "showing": "แสดง {{from}} – {{to}} จาก {{total}} รายการ"
    }
  },
  "encounters": {
    "title": "การมารับบริการ",
    "create": "สร้างการมารับบริการ",
    "filters": "ตัวกรอง",
    "filterLabels": {
      "status": "สถานะ",
      "class": "ประเภท",
      "fromDate": "ตั้งแต่วันที่",
      "toDate": "ถึงวันที่"
    },
    "filterPlaceholders": {
      "allStatuses": "ทุกสถานะ",
      "allClasses": "ทุกประเภท"
    },
    "clearFilters": "ล้างตัวกรอง",
    "fromDateAria": "ตั้งแต่วันที่",
    "toDateAria": "ถึงวันที่",
    "columns": {
      "encounterNumber": "เลขที่บริการ",
      "class": "ประเภท",
      "status": "สถานะ",
      "admitDate": "วันที่รับเข้า",
      "dischargeDate": "วันที่จำหน่าย",
      "location": "สถานที่",
      "chiefComplaint": "อาการสำคัญ"
    },
    "locationLabel": "สถานที่ #{{id}}",
    "loading": "กำลังโหลดการมารับบริการ...",
    "loadError": "โหลดการมารับบริการไม่สำเร็จ",
    "empty": "ผู้ป่วยรายนี้ยังไม่มีการมารับบริการ",
    "showing": "แสดง {{from}} – {{to}} จาก {{total}} รายการ"
  },
  "identifiers": {
    "nationalIdType": {
      "label": "ประเภทบัตรประชาชน",
      "none": "ไม่มี",
      "values": {
        "nric": "NRIC",
        "hkid": "HKID",
        "myKad": "MyKad",
        "aadhaar": "Aadhaar",
        "ktp": "KTP",
        "myNumber": "My Number",
        "thaiNationalId": "บัตรประจำตัวประชาชนไทย"
      },
      "country": {
        "nric": "สิงคโปร์",
        "hkid": "ฮ่องกง",
        "myKad": "มาเลเซีย",
        "aadhaar": "อินเดีย",
        "ktp": "อินโดนีเซีย",
        "myNumber": "ญี่ปุ่น",
        "thaiNationalId": "ไทย"
      },
      "placeholderByType": {
        "nric": "ตัวอย่าง: S1234567D",
        "myKad": "ตัวอย่าง: 850101-14-5678",
        "hkid": "ตัวอย่าง: A123456(3)",
        "aadhaar": "ตัวอย่าง: 2341 2341 2346",
        "thaiNationalId": "ตัวอย่าง: 1-2345-45678-78-1"
      }
    },
    "nationalIdCheck": {
      "checksumMismatch": "อักขระตรวจสอบไม่ตรงกับประเภทบัตรนี้ โปรดตรวจสอบหมายเลขกับเอกสารแสดงตนของผู้ป่วย",
      "unavailable": "ไม่สามารถตรวจสอบหมายเลขนี้ได้ โปรดตรวจสอบหมายเลขกับเอกสารแสดงตนของผู้ป่วย",
      "acknowledge": "ฉันได้ตรวจสอบหมายเลขนี้กับเอกสารแสดงตนแล้ว",
      "acknowledgeRequired": "โปรดตรวจสอบหมายเลขบัตรกับเอกสารแสดงตนและยืนยันก่อนบันทึก"
    }
  },
  "country": {
    "values": {
      "sg": "สิงคโปร์",
      "my": "มาเลเซีย",
      "th": "ไทย",
      "id": "อินโดนีเซีย",
      "ph": "ฟิลิปปินส์",
      "vn": "เวียดนาม",
      "hk": "ฮ่องกง",
      "tw": "ไต้หวัน",
      "jp": "ญี่ปุ่น",
      "kr": "เกาหลีใต้",
      "cn": "จีน",
      "in": "อินเดีย",
      "au": "ออสเตรเลีย",
      "nz": "นิวซีแลนด์"
    }
  },
  "language": {
    "values": {
      "en": "อังกฤษ",
      "zh": "จีน (กลาง)",
      "ms": "มาเลย์",
      "ta": "ทมิฬ",
      "th": "ไทย",
      "id": "อินโดนีเซีย",
      "vi": "เวียดนาม",
      "ja": "ญี่ปุ่น",
      "ko": "เกาหลี",
      "hi": "ฮินดี"
    }
  },
  "contact": {
    "addTitle": "เพิ่มผู้ติดต่อ",
    "editTitle": "แก้ไขผู้ติดต่อ",
    "name": "ชื่อ",
    "relationship": {
      "label": "ความสัมพันธ์",
      "selectPlaceholder": "เลือก...",
      "values": {
        "spouse": "คู่สมรส",
        "parent": "บิดามารดา",
        "child": "บุตร",
        "sibling": "พี่น้อง",
        "guardian": "ผู้ปกครอง",
        "friend": "เพื่อน",
        "other": "อื่นๆ"
      }
    },
    "phone": "โทรศัพท์",
    "email": "อีเมล",
    "emergencyContact": "ผู้ติดต่อฉุกเฉิน",
    "validation": {
      "nameRequired": "ต้องระบุชื่อผู้ติดต่อ",
      "relationshipRequired": "ต้องระบุความสัมพันธ์",
      "phoneRequired": "ต้องระบุหมายเลขโทรศัพท์",
      "invalidEmail": "อีเมลไม่ถูกต้อง"
    },
    "savedSuccess": "เพิ่มผู้ติดต่อสำเร็จ",
    "saveError": "เพิ่มผู้ติดต่อล้มเหลว"
  },
  "immunization": {
    "addTitle": "เพิ่มการสร้างเสริมภูมิคุ้มกัน",
    "vaccineName": "ชื่อวัคซีน",
    "vaccineNamePlaceholder": "เช่น ไข้หวัดใหญ่, COVID-19 (Pfizer), ไวรัสตับอักเสบ B",
    "vaccineCode": "รหัสวัคซีน (CVX)",
    "vaccineCodePlaceholder": "เช่น 141",
    "administeredDate": "วันที่ฉีด",
    "lotNumber": "หมายเลขล็อต",
    "lotNumberPlaceholder": "เช่น AB1234",
    "site": {
      "label": "ตำแหน่ง",
      "selectPlaceholder": "เลือกตำแหน่ง",
      "values": {
        "leftDeltoid": "กล้ามเนื้อเดลทอยด์ซ้าย",
        "rightDeltoid": "กล้ามเนื้อเดลทอยด์ขวา",
        "leftThigh": "ต้นขาซ้าย",
        "rightThigh": "ต้นขาขวา",
        "leftGluteal": "สะโพกซ้าย",
        "rightGluteal": "สะโพกขวา",
        "other": "อื่นๆ"
      }
    },
    "route": {
      "label": "วิธีบริหารยา",
      "selectPlaceholder": "เลือกวิธี",
      "values": {
        "intramuscular": "ฉีดเข้ากล้าม (IM)",
        "subcutaneous": "ฉีดใต้ผิวหนัง (SC)",
        "intradermal": "ฉีดในผิวหนัง (ID)",
        "oral": "รับประทาน",
        "intranasal": "พ่นจมูก"
      }
    },
    "doseAmount": "ปริมาณ",
    "doseAmountPlaceholder": "เช่น 0.5 mL",
    "administeredBy": "ผู้ฉีด",
    "administeredByPlaceholder": "ชื่อหรือรหัสบุคลากร",
    "nextDueDate": "วันที่ฉีดครั้งถัดไป",
    "notes": "หมายเหตุ",
    "notesPlaceholder": "หมายเหตุเพิ่มเติม...",
    "validation": {
      "vaccineNameRequired": "ต้องระบุชื่อวัคซีน",
      "administeredDateRequired": "ต้องระบุวันที่ฉีด"
    },
    "savedSuccess": "เพิ่มบันทึกการสร้างเสริมภูมิคุ้มกันแล้ว",
    "saveError": "เพิ่มบันทึกการสร้างเสริมภูมิคุ้มกันล้มเหลว"
  },
  "insurance": {
    "addTitle": "เพิ่มแผนประกัน",
    "submitLabel": "เพิ่มประกัน",
    "payerName": "ชื่อผู้จ่าย",
    "payerNamePlaceholder": "เช่น AIA สิงคโปร์",
    "payerId": "รหัสผู้จ่าย",
    "payerIdPlaceholder": "ตัวระบุผู้จ่าย",
    "planName": "ชื่อแผน",
    "planNamePlaceholder": "เช่น HealthShield Gold Max",
    "planType": {
      "label": "ประเภทแผน",
      "selectPlaceholder": "เลือกประเภท",
      "values": {
        "hmo": "HMO",
        "ppo": "PPO",
        "epo": "EPO",
        "pos": "POS",
        "government": "รัฐบาล",
        "private": "เอกชน",
        "corporate": "องค์กร",
        "other": "อื่นๆ"
      }
    },
    "memberId": "รหัสสมาชิก",
    "memberIdPlaceholder": "หมายเลขรหัสสมาชิก",
    "policyNumber": "หมายเลขกรมธรรม์",
    "policyNumberPlaceholder": "กรอกหมายเลขกรมธรรม์",
    "groupNumber": "หมายเลขกลุ่ม",
    "groupNumberPlaceholder": "หมายเลขกลุ่ม",
    "subscriberName": "ชื่อผู้เอาประกัน",
    "subscriberNamePlaceholder": "หากต่างจากผู้ป่วย",
    "subscriberRelationship": {
      "label": "ความสัมพันธ์กับผู้เอาประกัน",
      "values": {
        "self": "ตนเอง",
        "spouse": "คู่สมรส",
        "child": "บุตร",
        "parent": "บิดามารดา",
        "other": "อื่นๆ"
      }
    },
    "priority": {
      "label": "ลำดับความสำคัญ",
      "values": {
        "primary": "หลัก",
        "secondary": "รอง",
        "tertiary": "ลำดับสาม"
      }
    },
    "effectiveDate": "วันที่มีผล",
    "terminationDate": "วันที่สิ้นสุด",
    "copayAmount": "ร่วมจ่าย ($)",
    "coinsurancePercent": "ร่วมรับผิดชอบ (%)",
    "deductibleAmount": "ค่ารับผิดส่วนแรก ($)",
    "outOfPocketMax": "ยอดสูงสุดที่ออกเอง ($)",
    "preAuthRequired": "ต้องขออนุมัติล่วงหน้า",
    "notes": "หมายเหตุ",
    "notesPlaceholder": "หมายเหตุเพิ่มเติม...",
    "validation": {
      "payerNameRequired": "ต้องระบุชื่อผู้จ่าย",
      "planNameRequired": "ต้องระบุชื่อแผน",
      "memberIdRequired": "ต้องระบุรหัสสมาชิก",
      "effectiveDateRequired": "ต้องระบุวันที่มีผล"
    },
    "savedSuccess": "เพิ่มแผนประกันแล้ว",
    "saveError": "เพิ่มแผนประกันล้มเหลว"
  },
  "problem": {
    "addTitle": "เพิ่มปัญหา",
    "problemName": "ชื่อปัญหา",
    "problemNamePlaceholder": "เช่น เบาหวานชนิดที่ 2",
    "icdCode": "รหัส ICD-10",
    "icdSearchPlaceholder": "ค้นหารหัส ICD-10 หรือคำอธิบาย...",
    "onsetDate": "วันที่เริ่มเป็น",
    "severity": {
      "label": "ความรุนแรง",
      "values": {
        "mild": "เล็กน้อย",
        "moderate": "ปานกลาง",
        "severe": "รุนแรง"
      }
    },
    "notes": "หมายเหตุ",
    "notesPlaceholder": "หมายเหตุทางคลินิกเพิ่มเติม...",
    "validation": {
      "problemNameRequired": "ต้องระบุชื่อปัญหา"
    },
    "savedSuccess": "เพิ่มปัญหาในรายการแล้ว",
    "saveError": "เพิ่มปัญหาล้มเหลว"
  },
  "accounts": {
    "pageTitle": "บัญชีผู้ป่วย",
    "backToDashboard": "แดชบอร์ด",
    "searchPatientLabel": "ค้นหาผู้ป่วย",
    "searchPlaceholder": "ค้นหาตามชื่อหรือ MRN...",
    "searching": "กำลังค้นหา...",
    "noPatientsFound": "ไม่พบผู้ป่วย",
    "loadingAccount": "กำลังโหลดบัญชี...",
    "mrnLabel": "MRN",
    "generateStatement": "สร้างใบแจ้งยอด",
    "statementComingSoon": "การสร้างใบแจ้งยอดจะมาเร็วๆ นี้",
    "paymentPlan": "แผนการชำระเงิน",
    "paymentPlanComingSoon": "การตั้งค่าแผนการชำระเงินจะมาเร็วๆ นี้",
    "totalCharges": "ค่าใช้จ่ายรวม",
    "totalPayments": "ยอดชำระรวม",
    "adjustments": "การปรับปรุง",
    "outstandingBalance": "ยอดค้างชำระ",
    "transactionHistory": "ประวัติการทำรายการ",
    "columns": {
      "date": "วันที่",
      "type": "ประเภท",
      "description": "คำอธิบาย",
      "amount": "จำนวน",
      "balance": "ยอดคงเหลือ"
    },
    "transactionType": {
      "label": "ประเภท",
      "values": {
        "charge": "ค่าใช้จ่าย",
        "payment": "ชำระเงิน",
        "adjustment": "ปรับปรุง"
      }
    },
    "loadingTransactions": "กำลังโหลดรายการ...",
    "noTransactionsFound": "ไม่พบรายการ",
    "emptyState": "ค้นหาผู้ป่วยเพื่อดูบัญชี"
  },
  "proxies": {
    "title": "ผู้แทนที่ได้รับมอบอำนาจ",
    "description": "ผู้ดูแล ผู้ปกครอง และผู้แทนทางกฎหมายที่ได้รับอนุญาตให้เข้าถึงข้อมูลพอร์ทัลของผู้ป่วย รายการที่เพิกถอนจะถูกเก็บไว้สำหรับการตรวจสอบ",
    "addProxy": "เพิ่มผู้แทน",
    "newRelationshipHeading": "ความสัมพันธ์ผู้แทนใหม่",
    "proxyUserId": "ID ผู้ใช้ที่เป็นผู้แทน",
    "proxyUserIdPlaceholder": "ID ผู้ใช้ (จาก ผู้ดูแล → ผู้ใช้)",
    "proxyUserIdHelper": "ค้นหาใน ผู้ดูแล → ผู้ใช้ ส่วนประกอบเลือกผู้ใช้จะมีในการอัปเดตถัดไป",
    "relationship": {
      "label": "ความสัมพันธ์",
      "values": {
        "parent": "บิดามารดา",
        "legalGuardian": "ผู้ปกครองตามกฎหมาย",
        "spousePartner": "คู่สมรส / คู่ครอง",
        "adultChild": "บุตรที่บรรลุนิติภาวะ",
        "powerOfAttorney": "ผู้รับมอบอำนาจ",
        "healthcareAgent": "ผู้แทนทางการแพทย์"
      }
    },
    "accessLevel": {
      "label": "ระดับการเข้าถึง",
      "values": {
        "full": "เต็มรูปแบบ",
        "limited": "จำกัด",
        "emergency": "ฉุกเฉิน"
      },
      "descriptions": {
        "full": "ข้อมูลพอร์ทัลทั้งหมด — นัดหมาย ผลตรวจ ข้อความ แบบฟอร์ม",
        "limited": "เฉพาะนัดหมายและข้อความ (ปกติสำหรับวัยรุ่น)",
        "emergency": "เทียบเท่า break-glass สำหรับผู้แทนทางการแพทย์เมื่อผู้ป่วยไม่สามารถตัดสินใจได้"
      }
    },
    "startDate": "วันที่เริ่ม",
    "endDate": "วันที่สิ้นสุด",
    "startDateAria": "วันที่เริ่มมีผล",
    "endDateAria": "วันที่สิ้นสุดมีผล",
    "grantAccess": "ให้สิทธิ์เข้าถึงผู้แทน",
    "userIdRequired": "ต้องระบุ ID ผู้ใช้ที่เป็นผู้แทน",
    "createdSuccess": "สร้างความสัมพันธ์ผู้แทนแล้ว",
    "duplicateError": "ผู้นี้เป็นผู้แทนในความสัมพันธ์เดียวกันอยู่แล้ว",
    "invalidDataError": "ข้อมูลผู้แทนไม่ถูกต้อง",
    "createError": "สร้างผู้แทนล้มเหลว",
    "revokedSuccess": "เพิกถอนสิทธิ์ผู้แทนแล้ว",
    "revokeError": "เพิกถอนผู้แทนล้มเหลว",
    "emptyState": "ยังไม่ได้กำหนดผู้แทน ใช้ปุ่มด้านบนเพื่อให้สิทธิ์แก่ผู้ดูแล ผู้ปกครอง หรือผู้แทนทางการแพทย์",
    "sections": {
      "active": "ใช้งาน ({{count}})",
      "plannedInactive": "วางแผน / ไม่ใช้งาน ({{count}})",
      "revoked": "เพิกถอนแล้ว ({{count}})"
    },
    "userIdFallback": "ผู้ใช้ #{{id}}",
    "noEndDate": "(ไม่มีวันสิ้นสุด)",
    "revokedOn": "เพิกถอน {{date}}",
    "revokeTitle": "เพิกถอนสิทธิ์ผู้แทน",
    "confirmRevokeTitle": "เพิกถอนสิทธิ์ผู้แทน?",
    "confirmRevokeBody": "{{name}} จะสูญเสียสิทธิ์เข้าถึงข้อมูลพอร์ทัลของผู้ป่วยทันที บันทึกจะถูกเก็บไว้ในร่องรอยการตรวจสอบ",
    "confirmRevokeLabel": "เพิกถอนสิทธิ์"
  },
  "merge": {
    "title": "รวมผู้ป่วย",
    "description": "รวมบันทึกผู้ป่วยที่ซ้ำกัน ผู้ป่วยต้นทางจะถูกปิดใช้งานและข้อมูลทางคลินิกทั้งหมดจะถูกย้ายไปยังผู้ป่วยเป้าหมาย (ที่คงอยู่)",
    "sourceLabel": "ผู้ป่วยต้นทาง (จะถูกปิดใช้งาน)",
    "targetLabel": "ผู้ป่วยเป้าหมาย (บันทึกที่คงอยู่)",
    "clearSelection": "ล้างการเลือก",
    "searchPlaceholder": "ค้นหาตามชื่อ MRN หรือโทรศัพท์...",
    "fields": {
      "mrn": "MRN",
      "dob": "วันเกิด",
      "gender": "เพศ",
      "country": "ประเทศ",
      "phone": "โทรศัพท์",
      "email": "อีเมล"
    },
    "counts": {
      "encounters": "การเข้ารับการรักษา: {{count}}",
      "allergies": "การแพ้: {{count}}",
      "problems": "ปัญหา: {{count}}"
    },
    "samePatientWarning": "ต้นทางและเป้าหมายต้องเป็นผู้ป่วยต่างคน",
    "comparisonTitle": "เปรียบเทียบข้อมูลประชากร",
    "comparisonSubtitle": "ความแตกต่างถูกเน้นด้วยสีอำพัน",
    "columns": {
      "field": "ฟิลด์",
      "source": "ต้นทาง ({{mrn}})",
      "target": "เป้าหมาย ({{mrn}})"
    },
    "comparisonLabels": {
      "fullName": "ชื่อเต็ม",
      "mrn": "MRN",
      "dateOfBirth": "วันเกิด",
      "gender": "เพศ",
      "phone": "โทรศัพท์",
      "email": "อีเมล",
      "country": "ประเทศ",
      "nationalId": "เลขประจำตัวประชาชน"
    },
    "reasonLabel": "เหตุผลในการรวม",
    "reasonPlaceholder": "เหตุผลในการรวมบันทึกเหล่านี้ (จำเป็น)",
    "notesLabel": "หมายเหตุ (ไม่บังคับ)",
    "notesPlaceholder": "หมายเหตุเพิ่มเติมเกี่ยวกับการรวมนี้",
    "mergeButton": "รวมผู้ป่วย",
    "mergeSuccess": "รวมผู้ป่วยสำเร็จ",
    "mergeError": "รวมผู้ป่วยล้มเหลว",
    "successHeading": "การรวมเสร็จสมบูรณ์",
    "successBodyPrefix": "ผู้ป่วย {{mrn}} ถูกปิดใช้งานแล้ว ข้อมูลทางคลินิกทั้งหมดถูกย้ายไปยัง ",
    "successBodySuffix": ".",
    "confirmTitle": "ยืนยันการรวมผู้ป่วย",
    "confirmBodyPrefix": "การดำเนินการนี้",
    "confirmBodyEmphasis": "ไม่สามารถยกเลิกได้",
    "confirmBodySuffix": " ผู้ป่วย {{sourceMrn}} ({{sourceName}}) จะถูกปิดใช้งานและข้อมูลทางคลินิกทั้งหมดจะถูกย้ายไปยังผู้ป่วย {{targetMrn}} ({{targetName}})",
    "confirmButton": "ใช่ รวมผู้ป่วย",
    "swapSides": "Swap source and target",
    "preloadError": "Could not load the selected records.",
    "detailLoadError": "ไม่สามารถโหลดบันทึกผู้ป่วยได้"
  },
  "allergy": {
    "addTitle": "เพิ่มประวัติแพ้",
    "editTitle": "แก้ไขประวัติแพ้",
    "allergen": "สารก่อภูมิแพ้",
    "allergenPlaceholder": "เช่น เพนิซิลลิน ถั่วลิสง",
    "type": "ประเภท",
    "typeOptions": {
      "drug": "ยา",
      "food": "อาหาร",
      "environmental": "สิ่งแวดล้อม"
    },
    "severityLabel": "ระดับความรุนแรง",
    "severity": {
      "mild": "เล็กน้อย",
      "moderate": "ปานกลาง",
      "severe": "รุนแรง",
      "lifeThreatening": "คุกคามชีวิต"
    },
    "reaction": "ปฏิกิริยา",
    "reactionPlaceholder": "เช่น ลมพิษ ภาวะภูมิแพ้รุนแรง คลื่นไส้",
    "reactionOptions": {
      "rash": "ผื่น",
      "hives": "ลมพิษ",
      "anaphylaxis": "ภาวะภูมิแพ้รุนแรง",
      "swelling": "อาการบวม",
      "itching": "อาการคัน",
      "other": "อื่นๆ"
    },
    "onsetDate": "วันที่เริ่มมีอาการ",
    "notes": "หมายเหตุ",
    "notesPlaceholder": "หมายเหตุเพิ่มเติม...",
    "verifiedBy": "ผู้ตรวจสอบ",
    "noKnownAllergies": "ไม่มีประวัติแพ้ยาที่ทราบ",
    "savedSuccess": "เพิ่มประวัติแพ้สำเร็จ",
    "saveError": "เพิ่มประวัติแพ้ไม่สำเร็จ",
    "deletedSuccess": "ลบประวัติแพ้แล้ว"
  },
  "components": {
    "allergyBadge": {
      "title": "{{name}} ({{type}}) - {{severity}}"
    },
    "bradenScale": {
      "title": "แบบประเมิน Braden (ความเสี่ยงแผลกดทับ)",
      "footer": "ช่วงคะแนนรวม: 6-23 คะแนนยิ่งต่ำ ความเสี่ยงต่อการเกิดแผลกดทับยิ่งสูง",
      "scoreFormat": "คะแนน: {{score}} — {{riskBand}}",
      "riskBand": {
        "veryHigh": "ความเสี่ยงสูงมาก",
        "high": "ความเสี่ยงสูง",
        "moderate": "ความเสี่ยงปานกลาง",
        "mild": "ความเสี่ยงน้อย",
        "none": "ไม่มีความเสี่ยง"
      },
      "subscales": {
        "sensoryPerception": {
          "label": "{{n}}. การรับรู้ทางประสาทสัมผัส",
          "options": {
            "1": "{{n}} - จำกัดอย่างสมบูรณ์",
            "2": "{{n}} - จำกัดมาก",
            "3": "{{n}} - จำกัดเล็กน้อย",
            "4": "{{n}} - ไม่บกพร่อง"
          }
        },
        "moisture": {
          "label": "{{n}}. ความชื้น",
          "options": {
            "1": "{{n}} - เปียกชื้นตลอดเวลา",
            "2": "{{n}} - เปียกชื้นมาก",
            "3": "{{n}} - เปียกชื้นเป็นบางครั้ง",
            "4": "{{n}} - เปียกชื้นน้อยมาก"
          }
        },
        "activity": {
          "label": "{{n}}. การเคลื่อนไหว",
          "options": {
            "1": "{{n}} - นอนติดเตียง",
            "2": "{{n}} - นั่งบนเก้าอี้",
            "3": "{{n}} - เดินเป็นบางครั้ง",
            "4": "{{n}} - เดินบ่อย"
          }
        },
        "mobility": {
          "label": "{{n}}. ความสามารถในการขยับตัว",
          "options": {
            "1": "{{n}} - ขยับตัวไม่ได้เลย",
            "2": "{{n}} - จำกัดมาก",
            "3": "{{n}} - จำกัดเล็กน้อย",
            "4": "{{n}} - ไม่จำกัด"
          }
        },
        "nutrition": {
          "label": "{{n}}. ภาวะโภชนาการ",
          "options": {
            "1": "{{n}} - แย่มาก",
            "2": "{{n}} - อาจไม่เพียงพอ",
            "3": "{{n}} - เพียงพอ",
            "4": "{{n}} - ดีเยี่ยม"
          }
        },
        "frictionShear": {
          "label": "{{n}}. แรงเสียดทานและแรงเฉือน",
          "options": {
            "1": "{{n}} - มีปัญหา",
            "2": "{{n}} - อาจมีปัญหา",
            "3": "{{n}} - ไม่พบปัญหา"
          }
        }
      }
    },
    "morseFallScale": {
      "title": "แบบประเมินการพลัดตก Morse",
      "scoreFormat": "คะแนน: {{score}} — {{riskBand}}",
      "subscales": {
        "historyOfFalling": {
          "label": "{{n}}. ประวัติการพลัดตก",
          "options": {
            "0": "ไม่มี ({{score}})",
            "25": "มี ({{score}})"
          }
        },
        "secondaryDiagnosis": {
          "label": "{{n}}. การวินิจฉัยรอง",
          "options": {
            "0": "ไม่มี ({{score}})",
            "15": "มี ({{score}})"
          }
        },
        "ambulatoryAid": {
          "label": "{{n}}. อุปกรณ์ช่วยเดิน",
          "options": {
            "0": "ไม่มี / นอนพักบนเตียง / พยาบาลช่วย ({{score}})",
            "15": "ไม้ค้ำยัน / ไม้เท้า / รถเข็นช่วยเดิน ({{score}})",
            "30": "พิงเฟอร์นิเจอร์ ({{score}})"
          }
        },
        "ivHeparinLock": {
          "label": "{{n}}. การให้สารน้ำทางหลอดเลือด / Heparin Lock",
          "options": {
            "0": "ไม่มี ({{score}})",
            "20": "มี ({{score}})"
          }
        },
        "gait": {
          "label": "{{n}}. การเดิน",
          "options": {
            "0": "ปกติ / นอนพักบนเตียง / รถเข็น ({{score}})",
            "10": "อ่อนแรง ({{score}})",
            "20": "บกพร่อง ({{score}})"
          }
        },
        "mentalStatus": {
          "label": "{{n}}. สถานะทางจิตใจ",
          "options": {
            "0": "รับรู้ความสามารถของตนเองถูกต้อง ({{score}})",
            "15": "ประเมินความสามารถสูงเกินจริง / ลืมข้อจำกัด ({{score}})"
          }
        }
      },
      "interventions": {
        "high": "การจัดการความเสี่ยงสูง: ดำเนินมาตรการป้องกันการพลัดตกมาตรฐาน ติดสายรัดข้อมือแสดงความเสี่ยงการพลัดตกให้ผู้ป่วย ติดป้ายเตือนความเสี่ยงการพลัดตกที่หัวเตียง ให้ความรู้แก่ผู้ป่วยและครอบครัว ปรับเตียงให้อยู่ในตำแหน่งต่ำสุดและล็อคล้อ ตรวจสอบให้ปุ่มเรียกพยาบาลอยู่ในระยะที่เอื้อมถึง ใช้รองเท้ากันลื่น จัดตารางเข้าห้องน้ำ พิจารณาดูแลแบบ 1:1 หากจำเป็น",
        "moderate": "การจัดการความเสี่ยงปานกลาง: ดำเนินมาตรการป้องกันการพลัดตกมาตรฐาน ติดสายรัดข้อมือแสดงความเสี่ยงการพลัดตกให้ผู้ป่วย ให้ความรู้แก่ผู้ป่วยและครอบครัว ปรับเตียงให้อยู่ในตำแหน่งต่ำสุดและล็อคล้อ ตรวจสอบให้ปุ่มเรียกพยาบาลอยู่ในระยะที่เอื้อมถึง ใช้รองเท้ากันลื่น",
        "low": "การจัดการความเสี่ยงต่ำ: การพยาบาลพื้นฐานที่ดี ให้ความรู้ผู้ป่วยเรื่องการเคลื่อนไหวอย่างปลอดภัย แนะนำสภาพแวดล้อมและการใช้ปุ่มเรียกพยาบาล"
      }
    }
  },
  "banner": {
    "label": "ข้อมูลผู้ป่วย",
    "vip": "VIP",
    "vipTitle": "ผู้ป่วย VIP",
    "mrn": "MRN",
    "dob": "DOB",
    "ageSuffix": "ปี",
    "sex": "เพศ",
    "codeStatusAria": "รหัสกู้ชีพ: {{status}}",
    "isolationAria": "การแยกผู้ป่วย: {{status}}",
    "isolation": {
      "contact": "สัมผัส",
      "droplet": "ฝอยละออง",
      "airborne": "อากาศ",
      "none": "ไม่มี"
    },
    "fallRiskAria": "ความเสี่ยงพลัดตก: {{level}}",
    "fallRisk": {
      "label": "ความเสี่ยงพลัดตก",
      "low": "ต่ำ",
      "moderate": "ปานกลาง",
      "high": "สูง"
    },
    "pressureInjuryRisk": "ความเสี่ยงแผลกดทับ",
    "pressureInjuryRiskAria": "ความเสี่ยงแผลกดทับ: {{level}}",
    "interpreter": "ล่าม",
    "interpreterRequired": "ต้องการล่าม — {{language}}",
    "languageNotSpecified": "ไม่ระบุภาษา",
    "weightKg": "{{weight}} kg",
    "allergiesLabel": "การแพ้",
    "moreAllergies_one": "+อีก {{count}}",
    "moreAllergies_other": "+อีก {{count}}",
    "nkda": "NKDA",
    "allergiesUnknown": "ไม่ทราบประวัติการแพ้ — โหลดข้อมูลไม่สำเร็จ"
  },
  "chartFrame": {
    "navAriaLabel": "การนำทางเวชระเบียนผู้ป่วย",
    "tabs": {
      "summary": "สรุป",
      "encounters": "การมารับบริการ",
      "orders": "คำสั่งแพทย์",
      "results": "ผลตรวจ",
      "medications": "ยา",
      "notes": "บันทึก",
      "problems": "รายการปัญหา",
      "allergies": "การแพ้",
      "immunizations": "วัคซีน",
      "intakeOutput": "ปริมาณรับ-ขับ",
      "carePlans": "แผนการดูแล",
      "referrals": "การส่งต่อ",
      "familyHistory": "ประวัติครอบครัว",
      "socialHistory": "ประวัติทางสังคม",
      "surgicalHistory": "ประวัติการผ่าตัด",
      "advanceDirectives": "หนังสือแสดงเจตนา",
      "insurance": "ประกัน",
      "contacts": "ผู้ติดต่อ",
      "proxies": "ผู้รับมอบอำนาจ",
      "identifiers": "เลขประจำตัว",
      "addresses": "ที่อยู่",
      "consents": "Consents",
      "pregnancyStatus": "Pregnancy",
      "implantableDevices": "อุปกรณ์",
      "ccdaImports": "นำเข้า C-CDA"
    },
    "groups": {
      "clinical": "คลินิก",
      "history": "ประวัติ",
      "admin": "ธุรการ"
    },
    "breakGlass": {
      "auditBanner": "เข้าถึงฉุกเฉิน — กิจกรรมทั้งหมดอยู่ภายใต้การตรวจสอบ การเข้าถึงจะหมดอายุใน 15 นาที",
      "dialogTitle": "เวชระเบียนผู้ป่วยที่จำกัด",
      "dialogSubtitle": "ต้องการสิทธิ์เข้าถึงฉุกเฉิน",
      "dialogBody": "เวชระเบียนผู้ป่วยนี้ถูกจำกัดการเข้าถึง คุณต้องระบุเหตุผลในการเข้าถึง การเข้าถึงฉุกเฉินทั้งหมดจะถูกบันทึกและตรวจสอบ",
      "justificationLabel": "เหตุผลในการเข้าถึง",
      "justificationPlaceholder": "ระบุเหตุผลทางคลินิกในการเข้าถึงเวชระเบียนที่จำกัดนี้...",
      "justificationRequired": "การเข้าถึงฉุกเฉินต้องระบุเหตุผล",
      "requestError": "การขอเข้าถึงฉุกเฉินล้มเหลว โปรดลองอีกครั้งหรือติดต่อผู้ดูแลระบบ",
      "submitButton": "เข้าถึงเวชระเบียน",
      "submitting": "กำลังร้องขอ...",
      "passwordLabel": "ยืนยันรหัสผ่านของคุณ",
      "passwordPlaceholder": "ป้อนรหัสผ่านของคุณอีกครั้ง",
      "passwordRequired": "การเข้าถึงฉุกเฉินต้องใช้รหัสผ่านของคุณ",
      "passwordIncorrect": "รหัสผ่านไม่ถูกต้อง โปรดลองอีกครั้ง",
      "passwordHelp": "ยืนยันว่าเป็นคุณที่เวิร์กสเตชันนี้",
      "totpLabel": "รหัสยืนยัตัวตน",
      "totpPlaceholder": "รหัส 6 หลัก",
      "totpRequired": "การเข้าถึงฉุกเฉินต้องใช้รหัสจากแอปยืนยันตัวตนของคุณ",
      "totpIncorrect": "รหัสไม่ถูกต้อง โปรดลองอีกครั้ง",
      "totpHelp": "ยืนยัน่าเป็นคุณที่เวิร์กสเตชันนี้",
      "totpEnrollHint": "ยังไม่ได้ลทะเบียนแอปยืนยันตัวตน — โปรดลงทะเบียนในโปรไฟล์ของฉันเพื่อใช้การเข้าถึงฉุกเฉิน"
    },
    "invalidId": {
      "title": "รหัสผู้ป่วยไม่ถูกต้อง",
      "body": "รหัสผู้ป่วยที่ระบุไม่ถูกต้อง",
      "action": "ค้นหาผู้ป่วย"
    },
    "notFound": {
      "title": "ไม่พบผู้ป่วย",
      "body": "ไม่สามารถโหลดข้อมูลผู้ป่วยได้ ผู้ป่วยอาจไม่มีอยู่หรือคุณอาจไม่มีสิทธิ์เข้าถึง",
      "action": "ค้นหาผู้ป่วย"
    },
    "loadError": {
      "title": "โหลดแผนภูมิผู้ป่วยไม่สำเร็จ",
      "body": "ไม่สามารถโหลดแผนภูมิได้ โปรดลองอีกครั้ง",
      "action": "ลองอีกครั้ง"
    }
  },
  "address": {
    "title": "ที่อยู่",
    "addAddress": "เพิ่มที่อยู่",
    "newTitle": "ที่อยู่ใหม่",
    "editTitle": "แก้ไขที่อยู่",
    "loading": "กำลังโหลดที่อยู่...",
    "loadError": "ไม่สามารถโหลดข้อมูลที่อยู่ได้",
    "empty": "ยังไม่มีที่อยู่ในระบบ",
    "addressType": {
      "label": "ประเภท",
      "values": {
        "home": "บ้าน",
        "work": "ที่ทำงาน",
        "temporary": "ชั่วคราว",
        "billing": "ใบแจ้งหนี้"
      }
    },
    "fields": {
      "addressLine1": "ที่อยู่บรรทัดที่ 1",
      "addressLine2": "ที่อยู่บรรทัดที่ 2",
      "addressLine3": "ที่อยู่บรรทัดที่ 3",
      "district": "อำเภอ/เขต",
      "city": "เมือง",
      "stateProvince": "จังหวัด",
      "postalCode": "รหัสไปรษณีย์",
      "country": "ประเทศ"
    },
    "placeholders": {
      "addressLine1": "บ้านเลขที่ ถนน",
      "addressLine2": "ห้อง อาคาร ชั้น",
      "addressLine3": "อาคาร หมู่บ้าน",
      "district": "อำเภอ/ตำบล",
      "postalCode": "เช่น 10110",
      "country": "เช่น TH"
    },
    "primaryBadge": "หลัก",
    "setPrimary": "ตั้งเป็นที่อยู่หลัก",
    "primaryHelper": "(ที่อยู่อื่นจะถูกยกเลิกการเป็นที่อยู่หลัก)",
    "fromLabel": "ตั้งแต่: {{date}}",
    "toLabel": "ถึง: {{date}}",
    "save": "บันทึก",
    "update": "อัปเดต",
    "cancel": "ยกเลิก",
    "editTooltip": "แก้ไขที่อยู่",
    "removeTooltip": "ลบที่อยู่",
    "addedSuccess": "เพิ่มที่อยู่แล้ว",
    "addError": "เพิ่มที่อยู่ไม่สำเร็จ",
    "updatedSuccess": "อัปเดตที่อยู่แล้ว",
    "updateError": "อัปเดตที่อยู่ไม่สำเร็จ",
    "removedSuccess": "ลบที่อยู่แล้ว",
    "removeError": "ลบที่อยู่ไม่สำเร็จ",
    "requiredError": "ที่อยู่บรรทัดที่ 1 และประเทศจำเป็นต้องระบุ",
    "confirmRemoveTitle": "ลบที่อยู่",
    "confirmRemoveMessage": "คุณแน่ใจหรือไม่ว่าต้องการลบที่อยู่ประเภท{{type}}นี้?",
    "confirmRemoveLabel": "ลบ"
  },
  "allergies": {
    "pageTitle": "ประวัติแพ้",
    "addAllergy": "เพิ่มประวัติแพ้",
    "loading": "กำลังโหลดประวัติแพ้...",
    "loadError": "ไม่สามารถโหลดข้อมูลประวัติแพ้ได้",
    "nka": {
      "title": "ไม่มีประวัติแพ้ที่ทราบ (NKA)",
      "body": "ผู้ป่วยรายนี้ไม่มีการบันทึกประวัติแพ้"
    },
    "sections": {
      "active": "ประวัติแพ้ที่ใช้งานอยู่ ({{count}})",
      "inactive": "ประวัติแพ้ที่ไม่ใช้งาน ({{count}})"
    },
    "fields": {
      "reaction": "ปฏิกิริยา",
      "severity": "ความรุนแรง",
      "onset": "เริ่มมีอาการ",
      "recorded": "วันที่บันทึก"
    },
    "inactiveSummary": "ปฏิกิริยา: {{reaction}} | ความรุนแรง: {{severity}}",
    "deactivate": "ยกเลิกใช้งาน",
    "deactivateTooltip": "ยกเลิกใช้งานประวัติแพ้",
    "deleteTooltip": "ลบประวัติแพ้",
    "deactivatedSuccess": "ยกเลิกใช้งานประวัติแพ้แล้ว",
    "deactivateError": "ยกเลิกใช้งานประวัติแพ้ไม่สำเร็จ",
    "removedSuccess": "ลบประวัติแพ้แล้ว",
    "removeError": "ลบประวัติแพ้ไม่สำเร็จ",
    "confirmDeactivateTitle": "ยืนยันการยกเลิกใช้งาน",
    "confirmDeactivateMessage": "คุณแน่ใจหรือไม่ว่าต้องการยกเลิกใช้งาน \"{{name}}\"?",
    "confirmDeleteTitle": "ยืนยันการลบ",
    "confirmDeleteMessage": "คุณแน่ใจหรือไม่ว่าต้องการลบ \"{{name}}\" อย่างถาวร?",
    "confirmLabel": "ยืนยัน"
  },
  "problems": {
    "pageTitle": "รายการปัญหา",
    "addProblem": "เพิ่มปัญหา",
    "loading": "กำลังโหลดรายการปัญหา...",
    "loadError": "ไม่สามารถโหลดรายการปัญหาได้",
    "tabs": {
      "active": "ใช้งานอยู่ ({{count}})",
      "resolvedInactive": "แก้ไขแล้ว / ไม่ใช้งาน ({{count}})"
    },
    "sortByLabel": "จัดเรียงตาม:",
    "sortBy": {
      "onsetDate": "วันที่เริ่มมีอาการ",
      "severity": "ความรุนแรง"
    },
    "status": {
      "label": "สถานะ",
      "values": {
        "active": "ใช้งานอยู่",
        "resolved": "แก้ไขแล้ว",
        "inactive": "ไม่ใช้งาน"
      }
    },
    "empty": {
      "active": "ไม่มีปัญหาที่ใช้งานอยู่",
      "resolved": "ไม่มีปัญหาที่แก้ไขแล้วหรือไม่ใช้งาน"
    },
    "fields": {
      "onset": "เริ่มมีอาการ",
      "resolved": "แก้ไขแล้ว"
    },
    "resolveButton": "แก้ไขแล้ว",
    "reactivateButton": "เปิดใช้งานใหม่",
    "resolveTooltip": "ทำเครื่องหมายว่าแก้ไขแล้ว",
    "reactivateTooltip": "เปิดใช้งานใหม่",
    "statusUpdatedSuccess": "อัปเดตสถานะปัญหาแล้ว",
    "statusUpdateError": "อัปเดตสถานะปัญหาไม่สำเร็จ"
  },
  "immunizations": {
    "pageTitle": "การได้รับวัคซีน",
    "addImmunization": "เพิ่มการได้รับวัคซีน",
    "loading": "กำลังโหลดบันทึกการได้รับวัคซีน...",
    "loadError": "ไม่สามารถโหลดบันทึกการได้รับวัคซีนได้",
    "empty": "ไม่พบบันทึกการได้รับวัคซีน",
    "dueOverdue": "ครบกำหนด / เกินกำหนด ({{count}})",
    "upcoming": "วัคซีนที่จะถึงกำหนด ({{count}})",
    "dueLabel": "ครบกำหนด: {{date}}",
    "fromDateLabel": "วันที่เริ่มต้น",
    "toDateLabel": "วันที่สิ้นสุด",
    "fromDateAria": "วันที่เริ่มต้นการได้รับวัคซีน",
    "toDateAria": "วันที่สิ้นสุดการได้รับวัคซีน",
    "clearFilters": "ล้าง",
    "cvxLabel": "CVX: {{code}}",
    "columns": {
      "vaccine": "วัคซีน",
      "date": "วันที่รับ",
      "lotNumber": "เลขล็อต",
      "site": "ตำแหน่ง",
      "administeredBy": "ผู้ฉีด",
      "nextDue": "ครั้งถัดไป",
      "status": "สถานะ"
    },
    "dueStatus": {
      "label": "สถานะ",
      "values": {
        "overdue": "เกินกำหนด",
        "dueToday": "ครบกำหนดวันนี้",
        "upcoming": "ใกล้ถึงกำหนด"
      }
    }
  },
  "contacts": {
    "pageTitle": "ผู้ติดต่อ",
    "addContact": "เพิ่มผู้ติดต่อ",
    "loading": "กำลังโหลดผู้ติดต่อ...",
    "loadError": "ไม่สามารถโหลดข้อมูลผู้ติดต่อได้",
    "empty": "ยังไม่มีผู้ติดต่อในระบบ",
    "emergencyBadge": "ฉุกเฉิน",
    "sections": {
      "emergency": "ผู้ติดต่อฉุกเฉิน ({{count}})",
      "other": "ผู้ติดต่ออื่นๆ ({{count}})"
    },
    "editTooltip": "แก้ไขผู้ติดต่อ",
    "deleteTooltip": "ลบผู้ติดต่อ",
    "deletedSuccess": "ลบผู้ติดต่อแล้ว",
    "deleteError": "ลบผู้ติดต่อไม่สำเร็จ",
    "confirmDeleteTitle": "ลบผู้ติดต่อ",
    "confirmDeleteMessage": "คุณแน่ใจหรือไม่ว่าต้องการลบ \"{{name}}\"?",
    "confirmDeleteLabel": "ลบ"
  },
  "insurances": {
    "pageTitle": "ประกัน",
    "addInsurance": "เพิ่มประกัน",
    "loading": "กำลังโหลดข้อมูลประกัน...",
    "loadError": "ไม่สามารถโหลดข้อมูลประกันได้",
    "empty": {
      "title": "ไม่มีแผนประกัน",
      "body": "ผู้ป่วยรายนี้ยังไม่มีบันทึกแผนประกัน"
    },
    "sections": {
      "active": "แผนที่ใช้งานอยู่ ({{count}})",
      "inactive": "แผนที่ไม่ใช้งาน ({{count}})"
    },
    "status": {
      "label": "สถานะ",
      "values": {
        "active": "ใช้งานอยู่",
        "inactive": "ไม่ใช้งาน",
        "pendingVerification": "รอการตรวจสอบ"
      }
    },
    "fields": {
      "memberId": "รหัสสมาชิก",
      "groupNumber": "หมายเลขกลุ่ม",
      "effectiveDate": "วันที่เริ่มมีผล",
      "terminationDate": "วันสิ้นสุด",
      "copay": "ค่าร่วมจ่าย",
      "coinsurance": "ค่าร่วมประกัน",
      "deductible": "ค่าใช้จ่ายเริ่มต้น",
      "subscriber": "ผู้เอาประกัน"
    },
    "preAuthBadge": "ต้องขออนุมัติล่วงหน้า",
    "lastVerifiedLabel": "ตรวจสอบครั้งล่าสุด: {{date}}",
    "copayAmount": "${{amount}}",
    "coinsurancePercent": "{{percent}}%",
    "deductibleAmount": "${{amount}}",
    "verifyButton": "ตรวจสอบ",
    "verifyTooltip": "ตรวจสอบสิทธิ์",
    "editButton": "แก้ไข",
    "verifySuccess": "เริ่มการตรวจสอบสิทธิ์แล้ว",
    "verifyError": "ตรวจสอบสิทธิ์ไม่สำเร็จ"
  },
  "identifiersTab": {
    "pageTitle": "เลขประจำตัว",
    "addIdentifier": "เพิ่มเลขประจำตัว",
    "loading": "กำลังโหลดเลขประจำตัว...",
    "loadError": "ไม่สามารถโหลดข้อมูลเลขประจำตัวได้",
    "empty": "ยังไม่มีเลขประจำตัวในระบบ",
    "newTitle": "เลขประจำตัวใหม่",
    "type": {
      "label": "ประเภท",
      "selectPlaceholder": "เลือกประเภท...",
      "values": {
        "externalMrn": "MRN ภายนอก",
        "insuranceId": "รหัสประกัน",
        "studyId": "รหัสการศึกษา",
        "healthCard": "บัตรสุขภาพ",
        "nationalRegistry": "เลขทะเบียนราษฎร์",
        "passport": "หนังสือเดินทาง",
        "driverLicense": "ใบขับขี่",
        "other": "อื่นๆ"
      }
    },
    "fields": {
      "value": "เลข",
      "assigningAuthority": "หน่วยงานที่ออก",
      "effectiveDate": "วันที่เริ่มมีผล",
      "expiryDate": "วันหมดอายุ"
    },
    "placeholders": {
      "value": "เช่น 1-2345-45678-78-1",
      "assigningAuthority": "เช่น กระทรวงสาธารณสุข"
    },
    "status": {
      "label": "สถานะ",
      "values": {
        "active": "ใช้งานอยู่",
        "inactive": "ไม่ใช้งาน"
      }
    },
    "columns": {
      "type": "ประเภท",
      "value": "เลข",
      "assigningAuthority": "หน่วยงานที่ออก",
      "effectiveDate": "วันที่เริ่มมีผล",
      "expiryDate": "วันหมดอายุ",
      "status": "สถานะ",
      "actions": "ดำเนินการ"
    },
    "save": "บันทึก",
    "cancel": "ยกเลิก",
    "removeTooltip": "ลบเลขประจำตัว",
    "addedSuccess": "เพิ่มเลขประจำตัวแล้ว",
    "addError": "เพิ่มเลขประจำตัวไม่สำเร็จ",
    "removedSuccess": "ลบเลขประจำตัวแล้ว",
    "removeError": "ลบเลขประจำตัวไม่สำเร็จ",
    "requiredError": "ประเภทและเลขจำเป็นต้องระบุ",
    "confirmRemoveTitle": "ลบเลขประจำตัว",
    "confirmRemoveMessage": "คุณแน่ใจหรือไม่ว่าต้องการลบ \"{{type}}: {{value}}\"?",
    "confirmRemoveLabel": "ลบ"
  },
  "pages": {
    "advanceDirectives": {
      "title": "หนังสือแสดงเจตนาล่วงหน้า",
      "addButton": "เพิ่มหนังสือแสดงเจตนา",
      "emptyState": "ยังไม่มีหนังสือแสดงเจตนาล่วงหน้าที่บันทึกไว้สำหรับผู้ป่วยรายนี้",
      "loading": "กำลังโหลดหนังสือแสดงเจตนาล่วงหน้า...",
      "loadError": "ไม่สามารถโหลดหนังสือแสดงเจตนาล่วงหน้าได้",
      "documentLink": "ดูเอกสาร",
      "effectivePrefix": "มีผล:",
      "reviewPrefix": "ทบทวน:",
      "form": {
        "title": "หนังสือแสดงเจตนาล่วงหน้าใหม่",
        "labels": {
          "directiveType": "ประเภทหนังสือแสดงเจตนา",
          "status": "สถานะ",
          "effectiveDate": "วันที่มีผล",
          "notes": "หมายเหตุ",
          "optional": "ไม่บังคับ"
        },
        "placeholders": {
          "notes": "หมายเหตุเพิ่มเติมเกี่ยวกับหนังสือแสดงเจตนา..."
        },
        "selectTypePlaceholder": "เลือกประเภท...",
        "aria": {
          "effectiveDate": "วันที่มีผล"
        },
        "buttons": {
          "save": "บันทึกหนังสือแสดงเจตนา",
          "cancel": "ยกเลิก"
        }
      },
      "directiveType": {
        "DNR": "ไม่กู้ชีพ (DNR)",
        "living-will": "หนังสือแสดงเจตนาแบบลิฟวิ่งวิลล์",
        "POLST": "POLST / MOLST",
        "healthcare-proxy": "ผู้รับมอบอำนาจทางการแพทย์",
        "power-of-attorney": "หนังสือมอบอำนาจถาวร"
      },
      "directiveStatus": {
        "active": "มีผล",
        "inactive": "ไม่มีผล",
        "revoked": "เพิกถอนแล้ว",
        "pending": "รอทบทวน"
      },
      "toast": {
        "added": "เพิ่มหนังสือแสดงเจตนาล่วงหน้าแล้ว",
        "addFailed": "ไม่สามารถเพิ่มหนังสือแสดงเจตนาล่วงหน้าได้",
        "directiveTypeRequired": "ประเภทหนังสือแสดงเจตนาเป็นข้อมูลที่จำเป็น"
      }
    },
    "familyHistory": {
      "title": "ประวัติครอบครัว",
      "addButton": "เพิ่มรายการ",
      "emptyState": "ไม่มีการบันทึกประวัติครอบครัวสำหรับผู้ป่วยรายนี้",
      "loading": "กำลังโหลดประวัติครอบครัว...",
      "loadError": "ไม่สามารถโหลดประวัติครอบครัวได้",
      "onsetAge": "อายุที่เริ่มเป็น: {{age}} ปี",
      "outcomePrefix": "ผลลัพธ์:",
      "form": {
        "title": "รายการประวัติครอบครัวใหม่",
        "labels": {
          "relationship": "ความสัมพันธ์",
          "conditionName": "ชื่อโรค",
          "conditionCode": "รหัสโรค",
          "onsetAge": "อายุที่เริ่มเป็น",
          "outcome": "ผลลัพธ์",
          "optional": "ไม่บังคับ"
        },
        "placeholders": {
          "onsetAge": "อายุเป็นปี"
        },
        "selectRelationshipPlaceholder": "เลือกความสัมพันธ์...",
        "selectOutcomePlaceholder": "เลือกผลลัพธ์...",
        "buttons": {
          "save": "บันทึกรายการ",
          "cancel": "ยกเลิก"
        }
      },
      "relationship": {
        "Mother": "มารดา",
        "Father": "บิดา",
        "Sibling": "พี่น้อง",
        "Maternal Grandmother": "ยาย",
        "Maternal Grandfather": "ตา",
        "Paternal Grandmother": "ย่า",
        "Paternal Grandfather": "ปู่",
        "Child": "บุตร",
        "Aunt": "ป้า/น้า/อา",
        "Uncle": "ลุง/น้า/อา"
      },
      "outcome": {
        "alive": "ยังมีชีวิตอยู่",
        "deceased": "เสียชีวิตแล้ว",
        "unknown": "ไม่ทราบ"
      },
      "toast": {
        "added": "เพิ่มรายการประวัติครอบครัวแล้ว",
        "addFailed": "ไม่สามารถเพิ่มรายการประวัติครอบครัวได้",
        "relationshipAndConditionRequired": "ความสัมพันธ์และชื่อโรคเป็นข้อมูลที่จำเป็น"
      }
    },
    "socialHistory": {
      "title": "ประวัติทางสังคม",
      "editButton": "แก้ไข",
      "loading": "กำลังโหลดประวัติทางสังคม...",
      "loadError": "ไม่สามารถโหลดประวัติทางสังคม",
      "labels": {
        "smokingStatus": "สถานะการสูบบุหรี่",
        "alcoholUse": "การดื่มแอลกอฮอล์",
        "substanceUse": "การใช้สารเสพติด",
        "housing": "ที่พักอาศัย",
        "employment": "การจ้างงาน",
        "safetyScreening": "การคัดกรองความปลอดภัย",
        "notes": "หมายเหตุ"
      },
      "placeholders": {
        "notes": "หมายเหตุเพิ่มเติม..."
      },
      "buttons": {
        "save": "บันทึกการเปลี่ยนแปลง",
        "cancel": "ยกเลิก"
      },
      "toast": {
        "updated": "อัปเดตประวัติทางสังคมแล้ว",
        "updateFailed": "ไม่สามารถอัปเดตประวัติทางสังคม"
      },
      "smokingStatus": {
        "never": "ไม่เคยสูบบุหรี่",
        "former": "เคยสูบบุหรี่",
        "currentDaily": "สูบบุหรี่ทุกวันในปัจจุบัน",
        "currentOccasional": "สูบบุหรี่เป็นครั้งคราวในปัจจุบัน",
        "unknown": "ไม่ทราบ"
      },
      "alcoholUse": {
        "None": "ไม่มี",
        "Social/Occasional": "สังคม/บางครั้ง",
        "Moderate": "ปานกลาง",
        "Heavy": "หนัก",
        "In Recovery": "อยู่ในระยะฟื้นฟู",
        "Unknown": "ไม่ทราบ"
      },
      "substanceUse": {
        "None": "ไม่มี",
        "Current Use": "ใช้ในปัจจุบัน",
        "Former Use": "เคยใช้",
        "In Treatment": "อยู่ระหว่างการรักษา",
        "Unknown": "ไม่ทราบ"
      },
      "housing": {
        "Stable": "มั่นคง",
        "Unstable": "ไม่มั่นคง",
        "Homeless": "ไร้ที่อยู่อาศัย",
        "Assisted Living": "ที่พักแบบมีผู้ดูแล",
        "Nursing Facility": "สถานพยาบาล",
        "Unknown": "ไม่ทราบ"
      },
      "employment": {
        "Employed Full-Time": "ทำงานเต็มเวลา",
        "Employed Part-Time": "ทำงานนอกเวลา",
        "Self-Employed": "ประกอบอาชีพอิสระ",
        "Unemployed": "ว่างงาน",
        "Retired": "เกษียณ",
        "Student": "นักเรียน",
        "Disabled": "พิการไม่สามารถทำงาน",
        "Unknown": "ไม่ทราบ"
      },
      "safetyScreening": {
        "No Concerns": "ไม่มีข้อกังวล",
        "Concerns Identified": "ระบุข้อกังวลแล้ว",
        "Declined to Answer": "ปฏิเสธที่จะตอบ",
        "Not Screened": "ยังไม่ได้คัดกรอง"
      }
    },
    "surgicalHistory": {
      "title": "ประวัติการผ่าตัด",
      "addButton": "เพิ่มการผ่าตัด",
      "emptyState": "ไม่มีบันทึกประวัติการผ่าตัดสำหรับผู้ป่วยรายนี้",
      "loading": "กำลังโหลดประวัติการผ่าตัด...",
      "loadError": "ไม่สามารถโหลดประวัติการผ่าตัด",
      "cptLabel": "CPT {{code}}",
      "dateLabel": "วันที่: {{date}}",
      "surgeonLabel": "ศัลยแพทย์: {{name}}",
      "anesthesiaLabel": "การระงับความรู้สึก: {{type}}",
      "outcomePrefix": "ผลลัพธ์:",
      "complicationsPrefix": "ภาวะแทรกซ้อน:",
      "form": {
        "title": "รายการประวัติการผ่าตัดใหม่",
        "labels": {
          "procedureName": "ชื่อการผ่าตัด",
          "procedureCode": "รหัสการผ่าตัด",
          "procedureCodeSuffix": "(CPT)",
          "date": "วันที่",
          "surgeonName": "ชื่อศัลยแพทย์",
          "anesthesiaType": "ประเภทการระงับความรู้สึก",
          "laterality": "ข้าง",
          "outcome": "ผลลัพธ์",
          "complications": "ภาวะแทรกซ้อน"
        },
        "placeholders": {
          "surgeonName": "ชื่อศัลยแพทย์",
          "complications": "ภาวะแทรกซ้อนใด ๆ..."
        },
        "selectPlaceholder": "เลือก...",
        "aria": {
          "procedureDate": "วันที่ผ่าตัด"
        },
        "buttons": {
          "save": "บันทึกรายการ",
          "cancel": "ยกเลิก"
        }
      },
      "anesthesiaType": {
        "general": "ดมยาสลบทั่วไป",
        "regional": "ระงับความรู้สึกเฉพาะส่วน",
        "local": "ระงับความรู้สึกเฉพาะที่",
        "spinal": "บล็อกหลัง (สไปนัล)",
        "epidural": "บล็อกหลังเอพิดูรัล",
        "sedation": "การให้ยานอนหลับ",
        "none": "ไม่มี",
        "unknown": "ไม่ทราบ"
      },
      "laterality": {
        "left": "ซ้าย",
        "right": "ขวา",
        "bilateral": "ทั้งสองข้าง"
      },
      "toast": {
        "added": "เพิ่มรายการประวัติการผ่าตัดแล้ว",
        "addFailed": "ไม่สามารถเพิ่มรายการประวัติการผ่าตัด",
        "procedureNameRequired": "จำเป็นต้องระบุชื่อการผ่าตัด"
      }
    },
    "referralManagement": {
      "title": "การส่งต่อ",
      "addButton": "ส่งต่อใหม่",
      "refresh": "รีเฟรช",
      "loading": "กำลังโหลดการส่งต่อ...",
      "errorState": "ไม่สามารถโหลดการส่งต่อ",
      "emptyState": "ไม่มีการส่งต่อสำหรับผู้ป่วยรายนี้",
      "emptyStateFiltered": "ไม่มีการส่งต่อที่ตรงกับสถานะที่เลือก",
      "ariaFilterStatus": "กรองการส่งต่อตามสถานะ",
      "externalBadge": "ภายนอก",
      "filterStatus": {
        "allLabel": "ทุกสถานะ"
      },
      "table": {
        "type": "ประเภท",
        "reason": "เหตุผล",
        "specialty": "สาขา",
        "priority": "ลำดับความสำคัญ",
        "status": "สถานะ",
        "requested": "วันที่ขอ",
        "target": "วันที่เป้าหมาย"
      },
      "form": {
        "title": "ส่งต่อใหม่",
        "labels": {
          "referralType": "ประเภทการส่งต่อ",
          "priority": "ลำดับความสำคัญ",
          "specialty": "สาขา",
          "reason": "เหตุผล",
          "targetDate": "วันที่เป้าหมาย",
          "clinicalNotes": "บันทึกทางคลินิก",
          "optional": "ไม่บังคับ"
        },
        "placeholders": {
          "reason": "เหตุผลในการส่งต่อ",
          "clinicalNotes": "บันทึกทางคลินิกเพิ่มเติม..."
        },
        "selectReferralTypePlaceholder": "เลือกประเภท...",
        "selectSpecialtyPlaceholder": "เลือกสาขา...",
        "buttons": {
          "create": "สร้างการส่งต่อ",
          "cancel": "ยกเลิก"
        }
      },
      "referralType": {
        "consultation": "การปรึกษา",
        "transfer": "การโอนการดูแล",
        "second-opinion": "ความเห็นที่สอง",
        "diagnostic": "วินิจฉัย",
        "therapeutic": "บำบัด"
      },
      "priority": {
        "routine": "ตามปกติ",
        "urgent": "เร่งด่วน",
        "stat": "STAT"
      },
      "status": {
        "draft": "ฉบับร่าง",
        "submitted": "ส่งแล้ว",
        "accepted": "ตอบรับแล้ว",
        "scheduled": "นัดหมายแล้ว",
        "completed": "เสร็จสมบูรณ์",
        "cancelled": "ยกเลิกแล้ว"
      },
      "toasts": {
        "createSuccess": "สร้างการส่งต่อเรียบร้อย",
        "createFailed": "ไม่สามารถสร้างการส่งต่อ",
        "validationFailed": "จำเป็นต้องระบุประเภทการส่งต่อและเหตุผล"
      }
    }
  },
  "consents": {
    "title": "Consents",
    "grant": "Grant consent",
    "revoke": "Revoke",
    "confirmRevoke": "Revoke this consent? This records a revocation event and cannot be undone.",
    "loading": "Loading consents…",
    "loadError": "Failed to load consents.",
    "empty": "No consent records for this patient.",
    "table": {
      "scope": "Scope",
      "category": "Category",
      "decision": "Decision",
      "status": "Status",
      "effective": "Effective",
      "recorded": "Recorded",
      "actions": "Actions",
      "history": "Event history"
    },
    "toast": {
      "revoked": "Consent revoked.",
      "revokeFailed": "Failed to revoke consent."
    },
    "scope": {
      "patientPrivacy": "Patient privacy",
      "research": "Research",
      "treatment": "Treatment",
      "adr": "Adverse drug reaction"
    },
    "decision": {
      "permit": "Permit",
      "deny": "Deny"
    },
    "status": {
      "draft": "Draft",
      "proposed": "Proposed",
      "active": "Active",
      "rejected": "Rejected",
      "inactive": "Inactive",
      "enteredInError": "Entered in error"
    },
    "eventType": {
      "granted": "Granted",
      "revoked": "Revoked",
      "evaluated": "Evaluated",
      "accessGranted": "Access granted",
      "accessDenied": "Access denied"
    },
    "events": {
      "loading": "Loading history…",
      "empty": "No events recorded."
    },
    "form": {
      "title": "Grant consent",
      "submit": "Grant consent",
      "savedSuccess": "Consent recorded.",
      "saveError": "Failed to record consent."
    },
    "fields": {
      "scope": "Scope",
      "decision": "Decision",
      "category": "Category",
      "categoryPlaceholder": "e.g. medical-records, imaging",
      "performer": "Performer",
      "performerPlaceholder": "e.g. Patient/123 or Practitioner/45",
      "purpose": "Purpose",
      "dataClass": "Data class",
      "effectiveFrom": "Effective from",
      "effectiveTo": "Effective to",
      "notes": "Notes"
    }
  },
  "pregnancy": {
    "title": "Pregnancy & Lactation Screening",
    "currentHeading": "Current status",
    "recordHeading": "Record a status",
    "historyHeading": "History",
    "pregnancyLabel": "Pregnancy",
    "lactationLabel": "Lactation",
    "eddLabel": "Estimated due date",
    "sourceLabel": "Source",
    "notesLabel": "Notes",
    "recordButton": "Record status",
    "recordedOn": "Recorded {{date}}",
    "eddOn": "Estimated due date {{date}}",
    "outOfDate": "Out of date",
    "neverAsked": "Never asked",
    "notRecorded": "Not recorded",
    "noHistory": "No screening has been recorded for this patient.",
    "savedSuccess": "Screening status recorded",
    "saveError": "Could not record the screening status",
    "status": {
      "pregnant": "Pregnant",
      "notPregnant": "Not pregnant",
      "unknown": "Not known",
      "declined": "Declined to answer",
      "notApplicable": "Not applicable"
    },
    "lactationStatus": {
      "lactating": "Lactating",
      "notLactating": "Not lactating",
      "unknown": "Not known",
      "declined": "Declined to answer",
      "notApplicable": "Not applicable"
    },
    "source": {
      "patientReported": "Patient reported",
      "clinician": "Clinician",
      "lab": "Laboratory"
    },
    "columns": {
      "recordedAt": "Recorded",
      "pregnancy": "Pregnancy",
      "lactation": "Lactation",
      "edd": "Due date",
      "source": "Source",
      "notes": "Notes"
    },
    "errors": {
      "notesTooLong": "Notes must be 1000 characters or fewer",
      "eddOnlyWhenPregnant": "An estimated due date applies only to a pregnant status"
    }
  },
  "nursingAssessment": {
    "title": "Nursing Assessment",
    "subtitle": "The Morse and Braden scores recorded here update this patient's risk badges.",
    "assessmentType": "Assessment type",
    "type": {
      "admission": "Admission",
      "shift": "Shift",
      "focused": "Focused",
      "discharge": "Discharge"
    },
    "levelOfConsciousness": "Level of consciousness",
    "loc": {
      "alert": "Alert",
      "drowsy": "Drowsy",
      "lethargic": "Lethargic",
      "confused": "Confused",
      "unresponsive": "Unresponsive"
    },
    "mobilityLevel": "Mobility",
    "mobility": {
      "independent": "Independent",
      "assistiveDevice": "Assistive device",
      "assistOfOne": "Assist of one",
      "assistOfTwo": "Assist of two",
      "bedbound": "Bedbound"
    },
    "fallRiskFactors": "Fall risk factors",
    "fallRiskFactorsPlaceholder": "e.g. unsteady gait, IV pole, sedation",
    "pressureInjuryPresent": "Pressure injury already present",
    "painAssessment": "Pain assessment",
    "painPlaceholder": "Site, character, score, intervention",
    "generalNotes": "General notes",
    "save": "Save assessment",
    "saving": "Saving…",
    "saved": "Assessment recorded",
    "saveFailed": "Could not record the assessment",
    "notClinical": "Your account has no clinical identity, so it cannot sign a nursing assessment.",
    "history": "Previous assessments",
    "historyEmpty": "No assessments recorded for this encounter yet.",
    "bands": "Fall: {{fall}} · Pressure: {{pressure}}",
    "notScored": "not scored"
  },
  "duplicates": {
    "title": "Duplicate Review",
    "subtitle": "Candidate duplicate records found by the matching scanner. Review each pair and merge, or record that they are different people.",
    "noPermission": "You do not have permission to review duplicate patient records.",
    "loading": "Loading candidates...",
    "loadFailed": "Could not load the duplicate worklist.",
    "empty": "No candidates to review.",
    "dismissed": "Decision recorded.",
    "dismissFailed": "Could not record the decision.",
    "prev": "Previous",
    "next": "Next",
    "pageOf": "Page {{page}} of {{totalPages}}",
    "columns": {
      "score": "Score",
      "patients": "Records",
      "matchedOn": "Matched on",
      "detected": "Detected",
      "actions": "Actions"
    },
    "filters": {
      "status": "Review status",
      "minScore": "Min score"
    },
    "status": {
      "pending": "Pending",
      "reviewed": "Reviewed",
      "merged": "Merged",
      "not_duplicate": "Not a duplicate",
      "ignored": "Ignored"
    },
    "confidence": {
      "very_high": "Very high",
      "high": "High",
      "medium": "Medium",
      "low": "Low"
    },
    "matchedField": {
      "nameMatch": "Name",
      "dobMatch": "Date of birth",
      "genderMatch": "Gender",
      "nationalIdMatch": "National ID",
      "phoneMatch": "Phone",
      "addressMatch": "Address"
    },
    "actions": {
      "review": "Review",
      "dismiss": "Not a duplicate"
    },
    "dismissDialog": {
      "title": "Record a review decision",
      "body": "{{name1}} ({{mrn1}}) and {{name2}} ({{mrn2}}) will be removed from the worklist.",
      "reasonHelp": {
        "not_duplicate": "These are different people. The pair will not return unless the matching evidence materially improves.",
        "ignored": "Do not action this pair for now. Same suppression rule applies."
      },
      "notesPlaceholder": "Notes (optional)",
      "cancel": "Cancel",
      "confirm": "Record decision"
    },
    "restricted": {
      "title_one": "มี {{count}} คู่ที่เกี่ยวข้องกับผู้ป่วยซึ่งคุณไม่มีสิทธิ์ดู",
      "title_other": "มี {{count}} คู่ที่เกี่ยวข้องกับผู้ป่วยซึ่งคุณไม่มีสิทธิ์ดู",
      "body": "ผู้ป่วยของคุณรายหนึ่งอาจซ้ำกับเวชระเบียนที่สถานพยาบาลอื่น คู่ดังกล่าวไม่แสดงในรายการเพราะการตัดสินต้องดูผู้ป่วยที่อยู่นอกสิทธิ์ของคุณ — โปรดขอให้ฝ่ายเวชระเบียนตรวจสอบ"
    }
  },
  "__review_duplicateReview": "Duplicate-review worklist copy — ships English pending market sign-off; 'merge' vs 'link' is a records-management register that differs by market.",
  "recordExport": {
    "button": "ส่งออกเวชระเบียน",
    "exporting": "กำลังส่งออก…",
    "success": "ส่งออกเวชระเบียนแล้ว",
    "failed": "ส่งออกไม่สำเร็จ — ไม่มีการดาวน์โหลด",
    "tooltip": "ดาวน์โหลดเวชระเบียนฉบับสมบูรณ์ของผู้ป่วยรายนี้เป็นไฟล์แบบพกพา"
  },
  "device": {
    "addTitle": "บันทึกอุปกรณ์ฝังใน",
    "editTitle": "บันทึกการนำออก",
    "deviceName": "ชื่ออุปกรณ์",
    "deviceNamePlaceholder": "เช่น Evera MRI ICD, ขดลวดเคลือบยา",
    "deviceNameTooLong": "ชื่ออุปกรณ์ต้องไม่เกิน 512 ตัวอักษร",
    "deviceType": "ประเภทอุปกรณ์",
    "deviceTypePlaceholder": "เช่น เครื่องกระตุ้นหัวใจ, ขดลวด, อวัยวะเทียม",
    "udi": "UDI",
    "udiPlaceholder": "รหัสประจำตัวอุปกรณ์ทางการแพทย์",
    "deviceCode": "รหัสอุปกรณ์",
    "deviceCodeSystem": "ระบบรหัส",
    "deviceCodeSystemPlaceholder": "เช่น GMDN, SNOMED CT",
    "manufacturer": "ผู้ผลิต",
    "modelNumber": "รุ่น",
    "lotNumber": "เลขที่ล็อต",
    "serialNumber": "หมายเลขประจำเครื่อง",
    "implantDate": "วันที่ฝัง",
    "explantDate": "วันที่นำออก",
    "status": "สถานะ",
    "statusOptions": {
      "active": "ใช้งานอยู่",
      "inactive": "ไม่ใช้งาน",
      "explanted": "นำออกแล้ว"
    },
    "mriSafety": "ความปลอดภัย MRI",
    "mriSafetyOptions": {
      "safe": "ปลอดภัย",
      "conditional": "ปลอดภัยแบบมีเงื่อนไข",
      "unsafe": "ไม่ปลอดภัย",
      "unknown": "ไม่ทราบ"
    },
    "notes": "หมายเหตุ",
    "notesPlaceholder": "หมายเหตุเพิ่มเติม...",
    "savedSuccess": "บันทึกอุปกรณ์สำเร็จ",
    "saveError": "บันทึกอุปกรณ์ไม่สำเร็จ",
    "updatedSuccess": "บันทึกการนำออกสำเร็จ",
    "updateError": "บันทึกการนำออกไม่สำเร็จ",
    "explantRequiresDate": "อุปกรณ์ที่นำออกแล้วต้องมีวันที่นำออก",
    "explantBeforeImplant": "วันที่นำออกต้องไม่ก่อนวันที่ฝัง"
  },
  "devices": {
    "pageTitle": "อุปกรณ์ฝังใน",
    "addDevice": "บันทึกอุปกรณ์",
    "loading": "กำลังโหลดอุปกรณ์...",
    "loadError": "โหลดข้อมูลอุปกรณ์ไม่สำเร็จ",
    "empty": {
      "title": "ไม่มีอุปกรณ์ฝังใน",
      "body": "ยังไม่มีการบันทึกอุปกรณ์สำหรับผู้ป่วยรายนี้"
    },
    "sections": {
      "active": "อุปกรณ์ที่ใช้งานอยู่ ({{count}})",
      "history": "นำออกแล้ว / ไม่ใช้งาน ({{count}})"
    },
    "fields": {
      "udi": "UDI",
      "manufacturer": "ผู้ผลิต",
      "implanted": "วันที่ฝัง",
      "explanted": "วันที่นำออก",
      "mriSafety": "ความปลอดภัย MRI",
      "recorded": "บันทึกเมื่อ"
    },
    "recordExplant": "บันทึกการนำออก",
    "explantTooltip": "บันทึกการนำอุปกรณ์นี้ออก",
    "removeTooltip": "ลบรายการ",
    "removedSuccess": "ลบรายการอุปกรณ์แล้ว",
    "removeError": "ลบรายการอุปกรณ์ไม่สำเร็จ",
    "confirmDeleteTitle": "ยืนยันการลบ",
    "confirmDeleteMessage": "ลบ \"{{name}}\" ออกจากรายการ? ให้ลบเฉพาะรายการที่บันทึกผิด — หากต้องการบันทึกการนำออกจากร่างกาย ให้ใช้บันทึกการนำออก",
    "confirmLabel": "ยืนยัน"
  },
  "ccdaImports": {
    "title": "นำเข้า C-CDA",
    "subtitle": "เอกสารที่ได้รับเพื่อกระทบยอด เปิดการนำเข้าเพื่อทบทวนแต่ละรายการเข้าเวชระเบียน",
    "empty": "ไม่มีเอกสารนำเข้าสำหรับผู้ป่วยรายนี้",
    "loadError": "ไม่สามารถโหลดการนำเข้าได้",
    "received": "ได้รับ",
    "docType": "ประเภท",
    "status": "สถานะ",
    "pending": "รอดำเนินการ",
    "entries": "รายการ",
    "match": "ตรงกัน",
    "mismatch": "ID ไม่ตรงกัน",
    "statuses": {
      "pending": "รอดำเนินการ",
      "reviewed": "ทบทวนแล้ว",
      "dismissed": "ยกเลิก"
    },
    "docTypes": {
      "ccd": "CCD",
      "referral-note": "ใบนัดส่งตัว",
      "discharge-summary": "สรุปจำหน่าย",
      "other": "อื่น ๆ"
    }
  },
  "ccdaReview": {
    "title": "การนำเข้า #{{id}}",
    "back": "กลับไปรายการนำเข้า",
    "loadError": "ไม่สามารถโหลดการนำเข้านี้ได้",
    "mismatchWarning": "ตัวระบุผู้ส่งไม่ตรงกับผู้ป่วยรายนี้ โปรดยืนยันว่าเอกสารเป็นของผู้นี้ก่อนรับรายการใด ๆ",
    "unnamed": "รายการไม่มีชื่อ",
    "accept": "รับ",
    "reject": "ปฏิเสธ",
    "accepted": "ผสานรายการเข้าเวชระเบียนแล้ว",
    "rejected": "ปฏิเสธรายการแล้ว",
    "alreadyReviewed": "มีผู้อื่นทบทวนแล้ว — รีเฟรชด้านล่าง",
    "reviewError": "ทบทวนล้มเหลว",
    "confirmAcceptTitle": "รับเข้าเวชระเบียนหรือไม่?",
    "confirmAcceptMessage": "“{{name}}” จะถูกเพิ่มเข้าเวชระเบียนของผู้ป่วยรายนี้",
    "confirmRejectTitle": "ปฏิเสธรายการนี้หรือไม่?",
    "confirmRejectMessage": "“{{name}}” จะถูกนำออกจากคิว เอกสารต้นฉบับยังคงจัดเก็บอยู่",
    "sections": {
      "problem": "ปัญหา",
      "medication": "ยา",
      "allergy": "ภูมิแพ้"
    },
    "statuses": {
      "accepted": "รับแล้ว",
      "rejected": "ปฏิเสธแล้ว"
    }
  }
}
